import React from 'react'
import PropTypes from 'prop-types'

const Oembed = ({ url }) => {
  return url ? (
    <iframe src={url} title="Viewer: Embeded item" allowFullScreen />
  ) : <div className="oembed-placeholder" />
}

Oembed.propTypes = {
  url: PropTypes.string
}

export default Oembed
